import React from "react";
import { Container, Row, Col } from "react-bootstrap";

const benefitsList = [
  { 
    id: 1, 
    title: "Yuqori Sifat", 
    description: "Har bir poyabzal yuqori sifatli materiallardan tayyorlangan",
    icon: "las la-star"
  },
  { 
    id: 2, 
    title: "Mashhur Brendlar", 
    description: "Biz faqat dunyoning eng mashhur brendlarini taklif qilamiz",
    icon: "las la-gem"
  },
  { 
    id: 3, 
    title: "Tez Yetkazib Berish", 
    description: "O'zbekistonning barcha hududlariga BTS orqali yetkazib berish",
    icon: "las la-shipping-fast"
  },
  { 
    id: 4, 
    title: "14 Kun Ichida Yetkazib Berish", 
    description: "Buyurtmangiz 14 kun ichida qo'lingizga yetib keladi",
    icon: "las la-calendar-check"
  },
  { 
    id: 5, 
    title: "Doimiy Qo'llab-quvvatlash", 
    description: "Biz mahsulotlarimizni sifatli xizmat bilan ta'minlaymiz",
    icon: "las la-headset"
  },
  { 
    id: 6, 
    title: "Eshikkacha Yetkazib Berish", 
    description: "O'zbekistonning istalgan hududiga eshikkacha yetkazib berish",
    icon: "las la-home"
  },
];

const WhyChooseUs = () => {
  return (
    <section className="why-choose-us sp-t" id="benefits">
      <Container>
        <Row className="mb-5">
          <Col lg={8} className="mx-auto text-center">
            {/* - Section Heading - */}
            <div className="section-heading">
              <div className="sub-heading">
                <p>Bizning Va'damiz</p>
              </div>
              <div className="heading-title">
                <h2>Nega Bizni Tanlashingiz Kerak</h2>
              </div>
              <div className="heading-description">
                <p>
                  Biz sizga mahsulotni ko'rishdan tortib to poyabzalni kiyib yurishingizgacha bo'lgan jarayonda ajoyib tajriba taqdim etishga intilamiz.
                </p>
              </div>
            </div>
            {/* - Section Heading - */}
          </Col>
        </Row>

        <Row className="benefits-row">
          {benefitsList.map((benefit) => (
            <Col key={benefit.id} md={4} className="mb-4">
              <div className="benefit-card">
                <div className="benefit-icon">
                  <i className={benefit.icon}></i>
                </div>
                <div className="benefit-content">
                  <h3>{benefit.title}</h3>
                  <p>{benefit.description}</p>
                </div>
              </div>
            </Col>
          ))}
        </Row>
        
        <Row className="mt-5">
          <Col lg={10} className="mx-auto">
            <div className="quality-banner">
              <div className="quality-content text-center">
                <h3>O'z-o'zidan So'zlaydigan Sifat</h3>
                <p>Detallarni e'tiborga olish qanday farq yaratishini his qiling.</p>
                <a href="#collection" className="btn btn-light btn-lg mt-3">Kolleksiyani Ko'rish</a>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default WhyChooseUs;
